import React, { useState, useEffect, useRef } from 'react';
import { Modal, Form, Button, Row, Col } from 'react-bootstrap';
import { ServerPath } from '../../Constant';
import { toast } from 'react-toastify';
// import axios from 'axios';
import Search from '../../assets/images/svg/search.svg';
import { _axios } from '../../utils/axios';

const CreateLiveStream = ({ show, onHide }) => {
    const [formData, setFormData] = useState({
        object_type: 'temple',
        object_id: '',
        saint_id: '',
        stream_type: 'youtube',
        stream_category: 'live_darshan',
        youtube_video_id: '',
        stream_key: '',
        rtsp_url: '',
        stream_title: '',
        stream_title_mar: '',
        stream_title_hin: '',
        stream_title_guj: '',
        thumbnail_url: '',
        is_featured: false,
        is_active: 1,
        stream_mode: 'rtmp_push',
        orientation: 'portrait',
    });

    const [waypoints, setWaypoints] = useState([]);
    const [saints, setSaints] = useState([]);
    const [deities, setDeities] = useState([]);
    const [loadingWaypoints, setLoadingWaypoints] = useState(true);
    const [loadingSaints, setLoadingSaints] = useState(true);
    const [loadingDeities, setLoadingDeities] = useState(true);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [charCount, setCharCount] = useState({
        stream_title: 0,
        stream_title_mar: 0,
        stream_title_hin: 0,
        stream_title_guj: 0
    });

    const [showWaypointDropdown, setShowWaypointDropdown] = useState(false);
    const [waypointSearchTerm, setWaypointSearchTerm] = useState('');
    const waypointRef = useRef(null);

    const [showSaintDropdown, setShowSaintDropdown] = useState(false);
    const [saintSearchTerm, setSaintSearchTerm] = useState('');
    const saintRef = useRef(null);

    const [showDeityDropdown, setShowDeityDropdown] = useState(false);
    const [deitySearchTerm, setDeitySearchTerm] = useState('');
    const deityRef = useRef(null);

    useEffect(() => {
        fetchWaypoints();
        fetchSaints();
        fetchDeities();
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (waypointRef.current && !waypointRef.current.contains(event.target)) {
                setShowWaypointDropdown(false);
            }
            if (saintRef.current && !saintRef.current.contains(event.target)) {
                setShowSaintDropdown(false);
            }
            if (deityRef.current && !deityRef.current.contains(event.target)) {
                setShowDeityDropdown(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const fetchWaypoints = async () => {
        try {
            setLoadingWaypoints(true);
            const response = await _axios.get(`${ServerPath}/live-darshan/waypoints/list`);

            if (response.data.success === 1) {
                setWaypoints(response.data.data);
            } else {
                toast.error('Failed to load waypoints');
            }
        } catch (error) {
            console.error('Error fetching waypoints:', error);
            toast.error('Error loading waypoints');
        } finally {
            setLoadingWaypoints(false);
        }
    };

    const fetchSaints = async () => {
        try {
            setLoadingSaints(true);
            const response = await _axios.get(`${ServerPath}/live-darshan/saints/list`);

            if (response.data.success === 1) {
                setSaints(response.data.data);
            } else {
                toast.error('Failed to load saints');
            }
        } catch (error) {
            console.error('Error fetching saints:', error);
            toast.error('Error loading saints');
        } finally {
            setLoadingSaints(false);
        }
    };

    const fetchDeities = async () => {
        try {
            setLoadingDeities(true);
            const response = await _axios.get(`${ServerPath}/live-darshan/deities/list`);

            if (response.data.success === 1) {
                setDeities(response.data.data);
            } else {
                toast.error('Failed to load deities');
            }
        } catch (error) {
            console.error('Error fetching deities:', error);
            toast.error('Error loading deities');
        } finally {
            setLoadingDeities(false);
        }
    };

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (
            ['stream_title', 'stream_title_mar', 'stream_title_hin', 'stream_title_guj'].includes(name)
        ) {
            if (value.length > 50) {
                toast.error('Title cannot exceed 50 characters', {
                    toastId: 'length-error'
                });
                return;
            }

            setCharCount(prev => ({
                ...prev,
                [name]: value.length
            }));
        }


        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : value
        });
    };

    const handleStreamTypeChange = (e) => {
        const newStreamType = e.target.value;
        setFormData({
            ...formData,
            stream_type: newStreamType,
            youtube_video_id: newStreamType === 'cctv' ? '' : formData.youtube_video_id,
            stream_key: newStreamType === 'youtube' ? '' : formData.stream_key,
            rtsp_url: ''
        });
    };

    const generateStreamKey = (name) => {
        return name
            .toLowerCase()
            .replace(/\s+/g, '-')
            .replace(/[^\w\-]+/g, '')
            .replace(/\-\-+/g, '-')
            .replace(/^-+/, '')
            .replace(/-+$/, '');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isSubmitting || isSubmitted) return;

        try {
            setIsSubmitting(true);

            if (!formData.object_type || !formData.object_id || !formData.stream_type || !formData.stream_title || !formData.stream_title_guj || !formData.stream_title_hin || !formData.stream_title_mar) {
                toast.error('Please fill in all required fields');
                setIsSubmitting(false);
                return;
            }

            if (formData.stream_type === 'youtube' && !formData.youtube_video_id) {
                toast.error('YouTube video ID is required');
                setIsSubmitting(false);
                return;
            }

            if (formData.stream_type === 'cctv') {
    if (!formData.stream_key) {
        toast.error('Stream key is required for CCTV streams');
        setIsSubmitting(false);
        return;
    }
    if (formData.stream_mode === 'rtsp_pull' && !formData.rtsp_url) {
        toast.error('RTSP URL is required for RTSP Pull mode');
        setIsSubmitting(false);
        return;
    }
}

            if(!formData.thumbnail_url ){
                toast.error('Thumbnail URL is required');
                setIsSubmitting(false);
                return;
            }
            if (!formData.stream_category) {
    toast.error('Stream category is required');
    setIsSubmitting(false);
    return;
}

            const payload = {
                ...formData,
                stream_mode: formData.stream_type === 'cctv' ? formData.stream_mode : null,
            };

            const response = await _axios.post(`${ServerPath}/live-darshan/create`, payload);

            if (response.data.success === 1) {
                setIsSubmitted(true);
                toast.success('Stream added successfully');
                setTimeout(() => {
                    onHide();
                    window.location.reload();
                }, 1500);
            } else {
                toast.error(response.data.message || 'Failed to add stream');
                setIsSubmitting(false);
            }
        } catch (error) {
            console.error('Error adding stream:', error);
            toast.error(error.response?.data?.message || 'Error adding stream');
            setIsSubmitting(false);
        }
    };

    return (
        <Modal
            show={show}
            onHide={onHide}
            size="xl"
            centered
            style={{ borderRadius: '10px' }}
        >
            <div style={{ borderRadius: '10px' }}>
                <Modal.Header closeButton style={{ borderBottom: '1px solid #E2E8F0', padding: '20px 24px' }}>
                    <Modal.Title style={{ fontWeight: '600', fontSize: '22px' }}>
                        Add New Live Stream
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body style={{ padding: '24px' }}>
                    <Form>
                        <Row className='mb-3'>
                            <Col md={3}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500', fontSize: '16px' }}>
                                        Stream Type <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Select
                                        name="stream_type"
                                        value={formData.stream_type}
                                        onChange={handleStreamTypeChange}
                                        style={{
                                            height: '46px',
                                            border: '1px solid #E2E8F0',
                                            backgroundColor: '#FFFFFF',
                                            borderRadius: '6px'
                                        }}
                                    >
                                        <option value="youtube">YouTube Live Stream</option>
                                        <option value="cctv">CCTV Camera Stream</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>

                            <Col md={2}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500', fontSize: '16px' }}>
                                        Stream For <span className="text-danger">*</span>
                                    </Form.Label>
                                    <div className="d-flex flex-column gap-2 mt-2">
                                        <Form.Check
                                            type="radio"
                                            id="object-temple"
                                            name="object_type"
                                            value="temple"
                                            label="Temple"
                                            checked={formData.object_type === 'temple'}
                                            onChange={(e) => {
                                                setFormData({
                                                    ...formData,
                                                    object_type: 'temple',
                                                    object_id: '',
                                                    saint_id: '',
                                                    stream_title: '',
                                                    stream_title_mar: '',
                                                    stream_title_hin: '',
                                                    stream_title_guj: ''
                                                });
                                                setWaypointSearchTerm('');
                                                setSaintSearchTerm('');
                                                setDeitySearchTerm('');
                                            }}
                                        />
                                        <Form.Check
                                            type="radio"
                                            id="object-saint"
                                            name="object_type"
                                            value="saint"
                                            label="Saint"
                                            checked={formData.object_type === 'saint'}
                                            onChange={(e) => {
                                                setFormData({
                                                    ...formData,
                                                    object_type: 'saint',
                                                    object_id: '',
                                                    saint_id: '',
                                                    stream_title: '',
                                                    stream_title_mar: '',
                                                    stream_title_hin: '',
                                                    stream_title_guj: ''
                                                });
                                                setWaypointSearchTerm('');
                                                setSaintSearchTerm('');
                                                setDeitySearchTerm('');
                                            }}
                                        />
                                        <Form.Check
                                            type="radio"
                                            id="object-deity"
                                            name="object_type"
                                            value="deity"
                                            label="Deity"
                                            checked={formData.object_type === 'deity'}
                                            onChange={(e) => {
                                                setFormData({
                                                    ...formData,
                                                    object_type: 'deity',
                                                    object_id: '',
                                                    saint_id: '',
                                                    stream_title: '',
                                                    stream_title_mar: '',
                                                    stream_title_hin: '',
                                                    stream_title_guj: ''
                                                });
                                                setWaypointSearchTerm('');
                                                setSaintSearchTerm('');
                                                setDeitySearchTerm('');
                                            }}
                                        />
                                    </div>
                                </Form.Group>
                            </Col>

                            {formData.object_type === 'temple' ? (
                                <Col md={4}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500', fontSize: '16px' }}>
                                            Temple / Teertha <span className="text-danger">*</span>
                                        </Form.Label>
                                        <div className="position-relative" ref={waypointRef}>
                                            <Form.Control
                                                type="text"
                                                placeholder={loadingWaypoints ? "Loading..." : "Search Temple/Teertha..."}
                                                disabled={loadingWaypoints}
                                                value={showWaypointDropdown
                                                    ? waypointSearchTerm
                                                    : (waypoints.find(w => w.wpt_id === formData.object_id)?.wpt_name || '')
                                                }
                                                onChange={(e) => {
                                                    setWaypointSearchTerm(e.target.value);
                                                    setShowWaypointDropdown(true);
                                                }}
                                                onFocus={() => {
                                                    setWaypointSearchTerm('');
                                                    setShowWaypointDropdown(true);
                                                }}
                                                style={{
                                                    height: '46px',
                                                    paddingRight: '35px',
                                                    border: '1px solid #E2E8F0',
                                                    backgroundColor: '#FFFFFF',
                                                    borderRadius: '6px'
                                                }}
                                            />
                                            <img
                                                src={Search}
                                                alt="search"
                                                className="position-absolute"
                                                style={{
                                                    right: '10px',
                                                    top: '50%',
                                                    transform: 'translateY(-50%)',
                                                    width: '16px',
                                                    height: '16px',
                                                    pointerEvents: 'none'
                                                }}
                                            />

                                            {showWaypointDropdown && !loadingWaypoints && (
                                                <div
                                                    className="position-absolute bg-white border rounded shadow-sm"
                                                    style={{
                                                        width: '100%',
                                                        zIndex: 1000,
                                                        maxHeight: '200px',
                                                        overflowY: 'auto',
                                                        marginTop: '4px'
                                                    }}
                                                >
                                                    {waypoints
                                                        .filter(waypoint =>
                                                            waypoint.wpt_name.toLowerCase().includes(waypointSearchTerm.toLowerCase())
                                                        )
                                                        .map(waypoint => (
                                                            <div
                                                                key={waypoint.wpt_id}
                                                                className="p-2"
                                                                onClick={() => {
                                                                    setFormData({
                                                                        ...formData,
                                                                        object_id: waypoint.wpt_id,
                                                                        stream_key: formData.stream_type === 'cctv' ? generateStreamKey(waypoint.wpt_name) : formData.stream_key
                                                                    });
                                                                    setWaypointSearchTerm('');
                                                                    setShowWaypointDropdown(false);
                                                                }}
                                                                style={{
                                                                    cursor: 'pointer',
                                                                    backgroundColor: formData.object_id === waypoint.wpt_id ? '#F3F4F6' : 'white',
                                                                    transition: 'background-color 0.2s'
                                                                }}
                                                                onMouseEnter={(e) => e.target.style.backgroundColor = '#F3F4F6'}
                                                                onMouseLeave={(e) => {
                                                                    if (formData.object_id !== waypoint.wpt_id) {
                                                                        e.target.style.backgroundColor = 'white';
                                                                    }
                                                                }}
                                                            >
                                                                {waypoint.wpt_name}
                                                            </div>
                                                        ))
                                                    }
                                                    {waypoints.filter(waypoint =>
                                                        waypoint.wpt_name.toLowerCase().includes(waypointSearchTerm.toLowerCase())
                                                    ).length === 0 && (
                                                            <div className="p-2 text-muted text-center">
                                                                No Temple/Teertha found
                                                            </div>
                                                        )}
                                                </div>
                                            )}
                                        </div>
                                    </Form.Group>
                                </Col>
                            ) : formData.object_type === 'saint' ? (
                                <Col md={4}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500', fontSize: '16px' }}>
                                            Saint <span className="text-danger">*</span>
                                        </Form.Label>
                                        <div className="position-relative" ref={saintRef}>
                                            <Form.Control
                                                type="text"
                                                placeholder={loadingSaints ? "Loading..." : "Search Saint..."}
                                                disabled={loadingSaints}
                                                value={showSaintDropdown
                                                    ? saintSearchTerm
                                                    : (saints.find(s => s.saint_id === formData.object_id)?.saint_name || '')
                                                }
                                                onChange={(e) => {
                                                    setSaintSearchTerm(e.target.value);
                                                    setShowSaintDropdown(true);
                                                }}
                                                onFocus={() => {
                                                    setSaintSearchTerm('');
                                                    setShowSaintDropdown(true);
                                                }}
                                                style={{
                                                    height: '46px',
                                                    paddingRight: '35px',
                                                    border: '1px solid #E2E8F0',
                                                    backgroundColor: '#FFFFFF',
                                                    borderRadius: '6px'
                                                }}
                                            />
                                            <img
                                                src={Search}
                                                alt="search"
                                                className="position-absolute"
                                                style={{
                                                    right: '10px',
                                                    top: '50%',
                                                    transform: 'translateY(-50%)',
                                                    width: '16px',
                                                    height: '16px',
                                                    pointerEvents: 'none'
                                                }}
                                            />

                                            {showSaintDropdown && !loadingSaints && (
                                                <div
                                                    className="position-absolute bg-white border rounded shadow-sm"
                                                    style={{
                                                        width: '100%',
                                                        zIndex: 1000,
                                                        maxHeight: '200px',
                                                        overflowY: 'auto',
                                                        marginTop: '4px'
                                                    }}
                                                >
                                                    {saints
                                                        .filter(saint =>
                                                            saint.saint_name.toLowerCase().includes(saintSearchTerm.toLowerCase())
                                                        )
                                                        .map(saint => (
                                                            <div
                                                                key={saint.saint_id}
                                                                className="p-2"
                                                                onClick={() => {
                                                                    setFormData({
                                                                        ...formData,
                                                                        object_id: saint.saint_id,
                                                                        saint_id: saint.saint_id,
                                                                        stream_key: formData.stream_type === 'cctv' ? generateStreamKey(saint.saint_name) : formData.stream_key
                                                                    });
                                                                    setSaintSearchTerm('');
                                                                    setShowSaintDropdown(false);
                                                                }}
                                                                style={{
                                                                    cursor: 'pointer',
                                                                    backgroundColor: formData.object_id === saint.saint_id ? '#F3F4F6' : 'white',
                                                                    transition: 'background-color 0.2s'
                                                                }}
                                                                onMouseEnter={(e) => e.target.style.backgroundColor = '#F3F4F6'}
                                                                onMouseLeave={(e) => {
                                                                    if (formData.object_id !== saint.saint_id) {
                                                                        e.target.style.backgroundColor = 'white';
                                                                    }
                                                                }}
                                                            >
                                                                {saint.saint_name}
                                                            </div>
                                                        ))
                                                    }
                                                    {saints.filter(saint =>
                                                        saint.saint_name.toLowerCase().includes(saintSearchTerm.toLowerCase())
                                                    ).length === 0 && (
                                                            <div className="p-2 text-muted text-center">
                                                                No saints found
                                                            </div>
                                                        )}
                                                </div>
                                            )}
                                        </div>
                                    </Form.Group>
                                </Col>
                            ) : (
                                <Col md={4}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500', fontSize: '16px' }}>
                                            Deity <span className="text-danger">*</span>
                                        </Form.Label>
                                        <div className="position-relative" ref={deityRef}>
                                            <Form.Control
                                                type="text"
                                                placeholder={loadingDeities ? "Loading..." : "Search Deity..."}
                                                disabled={loadingDeities}
                                                value={showDeityDropdown
                                                    ? deitySearchTerm
                                                    : (deities.find(d => d.deity_id === formData.object_id)?.deity_name || '')
                                                }
                                                onChange={(e) => {
                                                    setDeitySearchTerm(e.target.value);
                                                    setShowDeityDropdown(true);
                                                }}
                                                onFocus={() => {
                                                    setDeitySearchTerm('');
                                                    setShowDeityDropdown(true);
                                                }}
                                                style={{
                                                    height: '46px',
                                                    paddingRight: '35px',
                                                    border: '1px solid #E2E8F0',
                                                    backgroundColor: '#FFFFFF',
                                                    borderRadius: '6px'
                                                }}
                                            />
                                            <img
                                                src={Search}
                                                alt="search"
                                                className="position-absolute"
                                                style={{
                                                    right: '10px',
                                                    top: '50%',
                                                    transform: 'translateY(-50%)',
                                                    width: '16px',
                                                    height: '16px',
                                                    pointerEvents: 'none'
                                                }}
                                            />

                                            {showDeityDropdown && !loadingDeities && (
                                                <div
                                                    className="position-absolute bg-white border rounded shadow-sm"
                                                    style={{
                                                        width: '100%',
                                                        zIndex: 1000,
                                                        maxHeight: '200px',
                                                        overflowY: 'auto',
                                                        marginTop: '4px'
                                                    }}
                                                >
                                                    {deities
                                                        .filter(deity =>
                                                            deity.deity_name.toLowerCase().includes(deitySearchTerm.toLowerCase())
                                                        )
                                                        .map(deity => (
                                                            <div
                                                                key={deity.deity_id}
                                                                className="p-2"
                                                                onClick={() => {
                                                                    setFormData({
                                                                        ...formData,
                                                                        object_id: deity.deity_id,
                                                                        stream_key: formData.stream_type === 'cctv' ? generateStreamKey(deity.deity_name) : formData.stream_key
                                                                    });
                                                                    setDeitySearchTerm('');
                                                                    setShowDeityDropdown(false);
                                                                }}
                                                                style={{
                                                                    cursor: 'pointer',
                                                                    backgroundColor: formData.object_id === deity.deity_id ? '#F3F4F6' : 'white',
                                                                    transition: 'background-color 0.2s'
                                                                }}
                                                                onMouseEnter={(e) => e.target.style.backgroundColor = '#F3F4F6'}
                                                                onMouseLeave={(e) => {
                                                                    if (formData.object_id !== deity.deity_id) {
                                                                        e.target.style.backgroundColor = 'white';
                                                                    }
                                                                }}
                                                            >
                                                                {deity.deity_name}
                                                            </div>
                                                        ))
                                                    }
                                                    {deities.filter(deity =>
                                                        deity.deity_name.toLowerCase().includes(deitySearchTerm.toLowerCase())
                                                    ).length === 0 && (
                                                        <div className="p-2 text-muted text-center">
                                                            No deities found
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </Form.Group>
                                </Col>
                            )}

                            <Col md={3}>
                                <Form.Group className='mb-3'>
                                    <Form.Label className="mb-2">
                                        Status <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Select
                                        style={{
                                            height: '46px',
                                            border: '1px solid #E2E8F0',
                                            backgroundColor: '#FFFFFF',
                                            borderRadius: '6px'
                                        }}
                                        value={formData.is_active}
                                        onChange={(e) => setFormData({ ...formData, is_active: parseInt(e.target.value) })}
                                        required
                                    >
                                        <option value={1}>Active</option>
                                        <option value={0}>Archived</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row className='mb-3'>
                            <Col md={3}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500', fontSize: '16px' }}>
                                        Stream Title (English) <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="stream_title"
                                        value={formData.stream_title}
                                        onChange={handleInputChange}
                                        required
                                        placeholder="English"
                                        style={{
                                            height: '46px',
                                            border: '1px solid #E2E8F0',
                                            backgroundColor: '#FFFFFF',
                                            borderRadius: '6px',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis'
                                        }}
                                    />
                                    <div
                                        className="position-absolute"
                                        style={{
                                            bottom: '15px',
                                            right: '20px',
                                            fontSize: '12px',
                                            color: '#6B7280'
                                        }}
                                    >
                                        {charCount.stream_title}/50
                                    </div>
                                </Form.Group>
                            </Col>

                            <Col md={3}>
                                <Form.Group>
                                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500', fontSize: '16px' }}>
                                        Stream Title (Marathi) <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="stream_title_mar"
                                        value={formData.stream_title_mar}
                                        onChange={handleInputChange}
                                        placeholder="मराठी"
                                        style={{
                                            height: '46px',
                                            border: '1px solid #E2E8F0',
                                            backgroundColor: '#FFFFFF',
                                            borderRadius: '6px',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis'
                                        }}
                                    />
                                    <div
                                        className="position-absolute"
                                        style={{
                                            bottom: '15px',
                                            right: '20px',
                                            fontSize: '12px',
                                            color: '#6B7280'
                                        }}
                                    >
                                        {charCount.stream_title}/50
                                    </div>
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group>
                                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500', fontSize: '16px' }}>
                                        Stream Title (Hindi) <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="stream_title_hin"
                                        value={formData.stream_title_hin}
                                        onChange={handleInputChange}
                                        placeholder="हिन्दी"
                                        style={{
                                            height: '46px',
                                            border: '1px solid #E2E8F0',
                                            backgroundColor: '#FFFFFF',
                                            borderRadius: '6px',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis'
                                        }}
                                    />
                                    <div
                                        className="position-absolute"
                                        style={{
                                            bottom: '15px',
                                            right: '20px',
                                            fontSize: '12px',
                                            color: '#6B7280'
                                        }}
                                    >
                                        {charCount.stream_title}/50
                                    </div>
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group>
                                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500', fontSize: '16px' }}>
                                        Stream Title (Gujarati) <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="stream_title_guj"
                                        value={formData.stream_title_guj}
                                        onChange={handleInputChange}
                                        placeholder="ગુજરાતી"
                                        style={{
                                            height: '46px',
                                            border: '1px solid #E2E8F0',
                                            backgroundColor: '#FFFFFF',
                                            borderRadius: '6px',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis'
                                        }}  
                                    />
                                    <div
                                        className="position-absolute"
                                        style={{
                                            bottom: '15px',
                                            right: '20px',
                                            fontSize: '12px',
                                            color: '#6B7280'
                                        }}
                                    >
                                        {charCount.stream_title}/50
                                    </div>
                                </Form.Group>
                            </Col>
                        </Row>

                        {formData.stream_type === 'youtube' && (
                            <Row className='mb-3'>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500', fontSize: '16px' }}>
                                            YouTube Video ID <span className="text-danger">*</span>
                                        </Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="youtube_video_id"
                                            value={formData.youtube_video_id}
                                            onChange={handleInputChange}
                                            required
                                            placeholder="e.g., dQw4w9WgXcQ"
                                            style={{
                                                height: '46px',
                                                border: '1px solid #E2E8F0',
                                                backgroundColor: '#FFFFFF',
                                                borderRadius: '6px'
                                            }}
                                        />
                                        <Form.Text className="text-muted">
                                            (e.g., youtube.com/watch?v=<strong>dQw4w9WgXcQ</strong>)
                                        </Form.Text>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500', fontSize: '16px' }}>
                                            Thumbnail URL <span className="text-danger">*</span>
                                        </Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="thumbnail_url"
                                            value={formData.thumbnail_url}
                                            onChange={handleInputChange}
                                            placeholder="https://example.com/thumbnail.jpg"
                                            style={{
                                                height: '46px',
                                                border: '1px solid #E2E8F0',
                                                backgroundColor: '#FFFFFF',
                                                borderRadius: '6px'
                                            }}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                        )}

{formData.stream_type === 'cctv' && (
    <>
        {/* Stream Mode Selector */}
        <Row className='mb-3'>
            <Col md={12}>
                <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500', fontSize: '16px' }}>
                    Stream Mode <span className="text-danger">*</span>
                </Form.Label>
                <div className="d-flex gap-4">
                    <div
                        onClick={() => setFormData({ ...formData, stream_mode: 'rtmp_push', rtsp_url: '' })}
                        style={{
                            flex: 1,
                            padding: '14px 18px',
                            borderRadius: '10px',
                            border: `2px solid ${formData.stream_mode === 'rtmp_push' ? '#5662F6' : '#E2E8F0'}`,
                            background: formData.stream_mode === 'rtmp_push' ? '#F0F1FF' : '#FFFFFF',
                            cursor: 'pointer',
                            transition: 'all 0.2s'
                        }}
                    >
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '4px' }}>
                            <div style={{
                                width: '16px', height: '16px', borderRadius: '50%',
                                border: `2px solid ${formData.stream_mode === 'rtmp_push' ? '#5662F6' : '#CBD5E0'}`,
                                display: 'flex', alignItems: 'center', justifyContent: 'center'
                            }}>
                                {formData.stream_mode === 'rtmp_push' && (
                                    <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#5662F6' }} />
                                )}
                            </div>
                            <span style={{ fontWeight: '600', fontSize: '14px', color: formData.stream_mode === 'rtmp_push' ? '#5662F6' : '#4A5568' }}>
                                RTMP Push
                            </span>
                            <span style={{
                                marginLeft: 'auto', fontSize: '10px', fontWeight: '600',
                                padding: '2px 8px', borderRadius: '20px',
                                background: '#E8F5E9', color: '#2E7D32'
                            }}>
                                3–5s latency
                            </span>
                        </div>
                        <div style={{ fontSize: '12px', color: '#718096', paddingLeft: '26px' }}>
                            NVR camera pushes stream to our server. Configure NVR with stream key.
                        </div>
                    </div>

                    <div
                        onClick={() => setFormData({ ...formData, stream_mode: 'rtsp_pull' })}
                        style={{
                            flex: 1,
                            padding: '14px 18px',
                            borderRadius: '10px',
                            border: `2px solid ${formData.stream_mode === 'rtsp_pull' ? '#5662F6' : '#E2E8F0'}`,
                            background: formData.stream_mode === 'rtsp_pull' ? '#F0F1FF' : '#FFFFFF',
                            cursor: 'pointer',
                            transition: 'all 0.2s'
                        }}
                    >
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '4px' }}>
                            <div style={{
                                width: '16px', height: '16px', borderRadius: '50%',
                                border: `2px solid ${formData.stream_mode === 'rtsp_pull' ? '#5662F6' : '#CBD5E0'}`,
                                display: 'flex', alignItems: 'center', justifyContent: 'center'
                            }}>
                                {formData.stream_mode === 'rtsp_pull' && (
                                    <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#5662F6' }} />
                                )}
                            </div>
                            <span style={{ fontWeight: '600', fontSize: '14px', color: formData.stream_mode === 'rtsp_pull' ? '#5662F6' : '#4A5568' }}>
                                RTSP Pull
                            </span>
                            <span style={{
                                marginLeft: 'auto', fontSize: '10px', fontWeight: '600',
                                padding: '2px 8px', borderRadius: '20px',
                                background: '#FFF3E0', color: '#E65100'
                            }}>
                                15–30s latency
                            </span>
                        </div>
                        <div style={{ fontSize: '12px', color: '#718096', paddingLeft: '26px' }}>
                            Our server pulls from camera's RTSP URL. Easier setup, higher latency.
                        </div>
                    </div>
                </div>
            </Col>
        </Row>

        {/* Stream Key — always shown for CCTV */}
        <Row md={3}>
            <Col md={formData.stream_mode === 'rtsp_pull' ? 6 : 6}>
                <Form.Group className="mb-3">
                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500', fontSize: '16px' }}>
                        Stream Key <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                        type="text"
                        name="stream_key"
                        value={formData.stream_key}
                        onChange={handleInputChange}
                        required
                        placeholder="e.g., temple-main-camera"
                        style={{
                            height: '46px',
                            border: '1px solid #E2E8F0',
                            backgroundColor: '#FFFFFF',
                            borderRadius: '6px'
                        }}
                    />
                    <Form.Text className="text-muted">
                        {formData.stream_mode === 'rtmp_push'
                            ? 'Configure your NVR to push to: rtmp://4.240.71.41:1935/live/YOUR-KEY'
                            : 'Unique identifier for this camera stream'}
                    </Form.Text>
                </Form.Group>
            </Col>

            {/* RTSP URL — only shown for RTSP Pull mode */}
            {formData.stream_mode === 'rtsp_pull' && (
                <Col md={6}>
                    <Form.Group className="mb-3">
                        <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500', fontSize: '16px' }}>
                            RTSP URL <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                            type="text"
                            name="rtsp_url"
                            value={formData.rtsp_url}
                            onChange={handleInputChange}
                            required
                            placeholder="rtsp://username:password@192.168.1.100:554/stream"
                            style={{
                                height: '46px',
                                border: '1px solid #E2E8F0',
                                backgroundColor: '#FFFFFF',
                                borderRadius: '6px'
                            }}
                        />
                        <Form.Text className="text-muted">
                            (eg: rtsp://user:pass@ip:port/path)
                        </Form.Text>
                    </Form.Group>
                </Col>
            )}
        </Row>

        <Row className='mb-3'>
            <Col md={6}>
                <Form.Group className="mb-3">
                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500', fontSize: '16px' }}>
                        Thumbnail URL <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                        type="text"
                        name="thumbnail_url"
                        value={formData.thumbnail_url}
                        onChange={handleInputChange}
                        placeholder="https://example.com/thumbnail.jpg"
                        style={{
                            height: '46px',
                            border: '1px solid #E2E8F0',
                            backgroundColor: '#FFFFFF',
                            borderRadius: '6px'
                        }}
                    />
                </Form.Group>
            </Col>
            <Col md={6}>
                <Form.Group className="mb-3">
                    <Form.Check
                        type="checkbox"
                        label="Featured Stream"
                        name="is_featured"
                        checked={formData.is_featured}
                        onChange={handleInputChange}
                        style={{ fontSize: '16px', marginTop: '30px' }}
                    />
                </Form.Group>
            </Col>
        </Row>
    </>
)}

                        {formData.stream_type === 'youtube' && (
                            <Row className="mb-3">
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Check
                                            type="checkbox"
                                            label="Featured Stream"
                                            name="is_featured"
                                            checked={formData.is_featured}
                                            onChange={handleInputChange}
                                            style={{ fontSize: '16px' }}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                        )}
                        <Row className='mb-3'>
    <Col md={3}>
        <Form.Group className="mb-3">
            <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500', fontSize: '16px' }}>
                Stream Category <span className="text-danger">*</span>
            </Form.Label>
            <Form.Select
                name="stream_category"
                value={formData.stream_category}
                onChange={handleInputChange}
                style={{
                    height: '46px',
                    border: '1px solid #E2E8F0',
                    backgroundColor: '#FFFFFF',
                    borderRadius: '6px'
                }}
            >
                <option value="live_darshan">Live Darshan</option>
                <option value="live_stream">Live Stream</option>
                <option value="live_aarti">Live Aarti</option>
            </Form.Select>
        </Form.Group>
    </Col>
    <Col md={3}>
        <Form.Group className="mb-3">
            <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500', fontSize: '16px' }}>
                Orientation <span className="text-danger">*</span>
            </Form.Label>
            <Form.Select
                name="orientation"
                value={formData.orientation}
                onChange={handleInputChange}
                style={{
                    height: '46px',
                    border: '1px solid #E2E8F0',
                    backgroundColor: '#FFFFFF',
                    borderRadius: '6px'
                }}
            >
                <option value="portrait">Portrait</option>
                <option value="landscape">Landscape</option>
            </Form.Select>
        </Form.Group>
    </Col>
</Row>
                    </Form>
                </Modal.Body>

                <div style={{ padding: '0 24px 24px 0', display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                        variant="secondary"
                        onClick={onHide}
                        className="me-2"
                        style={{
                            borderRadius: '6px',
                            padding: '10px 24px',
                            fontWeight: '500',
                            fontSize: '16px'
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="primary"
                        onClick={handleSubmit}
                        disabled={isSubmitting || isSubmitted}
                        style={{
                            backgroundColor: '#5662F6',
                            borderColor: '#5662F6',
                            borderRadius: '6px',
                            padding: '10px 40px',
                            fontWeight: '500',
                            fontSize: '16px'
                        }}
                    >
                        {isSubmitting ? 'Adding...' : 'Add Stream'}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default CreateLiveStream;